import { KitsProducts } from "../modules/kits"

export const KitsProductsPage = () => {
  return (
    <KitsProducts />
  )
}
